import {useContractFilter} from "@hooks/useContractFilter";
import React from "react";

export const Test: React.FC = () => {
    const btnClass = `mt-2 inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
    hover:bg-blue-700
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
    disabled:opacity-50
    `;
    const {aziendaCorrente, options, defaultOption, setFilter} = useContractFilter();
    //console.log("Lunghezza opts: ", options?.length)
    return <>
        <p>{aziendaCorrente?.denominazione}</p>
        <p>Contratti selezionato: #[{defaultOption?.key}]</p>
        <p>Elenco contratti</p>
        {options && options.length && <ul>
            {options.map((opt, index) => {
                return <li key={opt.key} className="w-full">
                    <span className="inline-flex mr-2">{opt.value}</span>
                    {defaultOption?.key !== opt.key &&
                        <button onClick={(e) => setFilter(opt.key)} className={btnClass}>Seleziona</button>}
                </li>
            })
            }
        </ul>}
    </>
}